import React, { FC, SyntheticEvent } from 'react';

import { LucidTheme } from '@lucid/theme';

import Button from '../button/button';

export interface TabProps {
  label: string;
  selected?: boolean;
  onClick: (evt: SyntheticEvent<Element, Event>) => void;
}

const Tab: FC<TabProps> = ({ label, onClick, selected }) => {
  return (
    <Button
      css={(theme: LucidTheme) => [
        {
          backgroundColor: theme.colors.white,
          border: 'none',
          color: theme.colors.coolGrey[60],
          '&:hover, &:focus': {
            backgroundColor: theme.colors.coolGrey[5],
            color: theme.colors.coolGrey[100],
          }
        },
        selected && {
          backgroundColor: theme.colors.coolGrey[5],
          color: theme.colors.coolGrey[100],
        }
      ]}
      onClick={onClick}
      variant="filter"
    >
      {label}
    </Button>
  );
};

export default Tab;
export { Tab };
